import React from 'react';
import { Ticket } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { isExhibitionActive, openExhibitionModal } from './ExhibitionModal';

const labels = {
  ru: 'KazBuild 2–4 сен',
  kz: 'KazBuild 2–4 қыр',
  en: 'KazBuild Sep 2–4',
  ar: 'KazBuild 2–4 سبتمبر'
};

/**
 * Persistent header badge. Dispatches an event to open the global ExhibitionModal.
 */
export const ExhibitionHeaderBadge = () => {
  const { language } = useLanguage();

  if (!isExhibitionActive()) return null;

  return (
    <button
      onClick={openExhibitionModal}
      className="hidden md:inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full bg-gradient-to-r from-[#8b4444] to-[#a94f4f] hover:from-[#7a3838] hover:to-[#984545] text-white text-xs font-bold transition-all shadow-sm hover:shadow-md"
      data-testid="exhibition-header-badge"
      title={labels[language] || labels.ru}
    >
      <Ticket className="w-3.5 h-3.5" />
      <span className="hidden xl:inline">{labels[language] || labels.ru}</span>
      <span className="xl:hidden">KazBuild</span>
    </button>
  );
};

export default ExhibitionHeaderBadge;
